import { generatePermission } from "./generatePermission";
import { generatePermissionGroup } from "./generatePermissionGroup";

export const PERMISION = {
  SUBSCRIBED: "SUBSCRIBED",
  ACCOUNTS:{
    REGISTER: generatePermissionGroup({
      SHOW_ALL: generatePermission("AR01"),
      ASSET: generatePermission("AR02"),
      COST_OF_SALE: generatePermission("AR03"),
      EQUITY: generatePermission("AR04"),
      EXPENSE: generatePermission("AR05"),
      INCOME: generatePermission("AR06"),
      INCOME_TAX: generatePermission("AR07"),
      LIABILITY: generatePermission("AR08"),
      OTHER_EXPENSE: generatePermission("AR09"),
      OTHER_INCOME: generatePermission("AR10"),
    }),
    TRANSACTION: generatePermissionGroup({
      OPENING_BALANCE: generatePermission("AT01"),
      GENERAL_ENTRY: generatePermission("AT02"),
      CLOSING_FINANCE_YEAR: generatePermission("AT03")
    }),
    REPORT: generatePermissionGroup({
      /** 
       * NOTE: 
       * 1. Hak akses belum di setup karena feature REPORT belum ada di develope
      */
      TRANSACTION_DETAIL: generatePermission("AP01"),
      BALANCE_SHEET: generatePermission("AP02"),
      PROFIT_AND_LOSS: generatePermission("AP03"),
      BUDGET_MANAGER: generatePermission("AP04"),
      BUDGET_VARIANCE: generatePermission("AP05"),
      DASHBOARD: generatePermission("AP06"),
    }),
    JOURNAL: generatePermissionGroup({
      /** 
       * NOTE: 
       * 1. Hak akses belum di setup karena feature JOURNAL belum ada di develope
      */
      GENERAL: generatePermission("AJ01"),
    }),
    FIND: generatePermissionGroup({
      /** 
       * NOTE: 
       * 1. Hak akses belum di setup karena feature FIND belum ada di develope
      */
      FINANCE: generatePermission("AF01"),
    }),
  },
  ASET_MANAGEMENT:{
    REGISTER: generatePermissionGroup({
      BY_GROUP: generatePermission("MR01")
    }),
    TRANSACTION: generatePermissionGroup({
      PROFILE_ASSET: generatePermission("MT01"),
      DEPRECIATION: generatePermission("MT02")
    }),
    REPORT: generatePermissionGroup({
      /** 
       * NOTE: 
       * 1. Hak akses belum di setup karena feature REPORT belum ada di develope
      */
      DUMMY: generatePermission("MT01"),
    }),
    JOURNAL: generatePermissionGroup({
      /** 
       * NOTE: 
       * 1. Hak akses belum di setup karena feature JOURNAL belum ada di develope
      */
      DUMMY: generatePermission("MT01"),
    }),
    FIND: generatePermissionGroup({
      /** 
       * NOTE: 
       * 1. Hak akses belum di setup karena feature FIND belum ada di develope
      */
      DUMMY: generatePermission("MT01"),
    }),
  },
  FINANCE:{
    REGISTER: generatePermissionGroup({
      BY_DATE_RANGE: generatePermission("FR01"),
      BY_CARD: generatePermission("FR02"),
      BY_LOCATION: generatePermission("FR03"),
      REFERENCE_ID: generatePermission("FR04"),
      RECONCILLIATION: generatePermission("FR05"),
    }),
    TRANSACTION: generatePermissionGroup({
      SPEND_MONEY: generatePermission("FT01"),
      RECEIVE_MONEY: generatePermission("FT02"),
      TRANSFER_MONEY: generatePermission("FT03"),
      RECONCILE_ACCOUNT: generatePermission("FT04"),
      TRANSACTION_JOURNAL: generatePermission("FT05"),
    }),
    REPORT: generatePermissionGroup({
      /** 
       * NOTE: 
       * 1. Yang baru di setup cuman Permission DASBOARD ( FP09 ) tetapi di bagian tab belum di setup hak aksesnya
      */
      DASHBOARD: generatePermission("FP09"),
    }),
    JOURNAL: generatePermissionGroup({
      /** 
       * NOTE: 
       * 1. Yang baru di setup cuman Permission GENERAL ( FJ09 ) tetapi di bagian tab belum di setup hak aksesnya
      */
      GENERAL: generatePermission("FJ01"),
    }),
    FIND: generatePermissionGroup({
      /** 
       * NOTE: 
       * 1. Yang baru di setup cuman Permission FINANCE ( FF02 )
      */
      FINANCE: generatePermission("FF02"),
    }),
  },
  SALES: {
    REGISTER: generatePermissionGroup({
      BY_DATE_RANGE: generatePermission("SR01"),
      BY_CARD: generatePermission("SR02"),
      BY_LOCATION: generatePermission("SR03"),
      BY_REFERENCE_ID: generatePermission("SR04"),
      ALL_INVOICE: generatePermission("SR05"),
      AGED_RECEIVABLE: generatePermission("SR06"),
      QUOTATION: generatePermission("SR07"),
      WORK_ORDER: generatePermission("SR08"),
      RERUND_ITEM: generatePermission("SR09")
    }),
    TRANSACTION: generatePermissionGroup({
      CUSTOMER_QUOTATION: generatePermission("ST01"),
      CREATE_RETURNED_RECORD: generatePermission("ST02"),
      CUSTOMER_QUOTATION_APPROVAL: generatePermission("ST03"),
      CUSTOMER_ORDER: generatePermission("ST04"),
      CUSTOMER_ORDER_APPROVAL: generatePermission("ST05"),
      CUSTOMER_DEPOSIT_APPROVAL: generatePermission("ST06"),
      INVOICE_APPROVAL: generatePermission("ST07"),
      PAYMENT_INVOICE_APPROVAL: generatePermission("ST08"),
      RETURN_ITEMS_APPROVAL: generatePermission("ST09"),
      REFUND_RETURN_APPROVAL: generatePermission("ST10"),
      ADJUSTMENT_FREIGHT_INVOICE: generatePermission("ST11")
    }),
    REPORT: generatePermissionGroup({
      /**
       * NOTE:
       * 1. Hak akses yang baru di setup baru hanya ANALYSE SALES PERIODE, ANALYSE SALES COMPARATION dan DASHBOARD ( SP04, SP05 dan SP13 ) saja dikarenakan menu yang lain belum di develope
      */
      AGING_SUMMARY: generatePermission("SP04"),
      AGING_DETAIL: generatePermission("SP04"),
      SALES_SUMMARY: generatePermission("SP04"),
      ANALYSE_SALES_PERIODE: generatePermission("SP04"),
      ANALYSE_SALES_COMPARATION: generatePermission("SP05"),
      ANALYSE_SALES_MONTHLY: generatePermission("SP04"),
      CUSTOMER_SALES_DETAIL: generatePermission("SP04"),
      SALESPERSON_SALES_SUMMARY: generatePermission("SP04"),
      SALESPERSON_SALES_DETAIL: generatePermission("SP04"),
      ALL_SALES: generatePermission("SP04"),
      PAYMENT_HISTORY: generatePermission("SP04"),
      SALES_RECEIVALBLE_JOURNAL: generatePermission("SP04"),
      DASHBOARD: generatePermission("SP13")
    }),
    JOURNAL: generatePermissionGroup({
      /** 
       * NOTE: 
       * 1. Permission GENERAL belum di setup
       * 2. Permission TRANSFER MONEY belum di setup
       * 3. Permission DISBURSMENT belum di setup
       * 4. Permission RECEIPTS belum di setup
       * 5. Yang baru di setup cuman Permission SALES ( SJ05 ) tetapi di bagian tab belum di setup hak aksesnya
       * 6. Permission PURCHASES belum di setup
       * 7. Permission INVENTORY belum di setup
       * 8. Permission ALL belum di setup
      */
     SALES: generatePermission("SJ05")
    }),
    FIND: generatePermissionGroup({
      /** 
       * NOTE:
       * 1. Cuman perlu setup perminssion SALES ( PF03 ) saja dikarenakan default tab SALES
      */
     SALES: generatePermission("SF03")
    })
  },
  PURCHASES: {
    REGISTER: generatePermissionGroup({
      BY_DATE_RANGE: generatePermission("PR01"),
      BY_CARD: generatePermission("PR02"),
      BY_LOCATION: generatePermission("PR03"),
      BY_REFERENCE_ID: generatePermission("PR04"),
      BILLS_ITEM: generatePermission("PR05"),
      BILLS_SERVICE: generatePermission("PR06"),
      AGED_PAYABLE: generatePermission("PR07"),
      WORK_ORDER: generatePermission("PR08"),
      RECEIVED_REJECTED: generatePermission("PR09"),
    }),
    TRANSACTION: generatePermissionGroup({
      CREATE_PURCHASE_ORDER: generatePermission("PT01"),
      CREATE_BILL_SERVICE: generatePermission("PT02"),
      CREATE_REJECTED_RECORDS: generatePermission("PT03"),
      ADJUSTMENT_FREIGHT_BILL: generatePermission("PT04"),
      APPROVAL_PO: generatePermission("PT05"),
      APPROVAL_BILL_SERVICE: generatePermission("PT06"),
      APPROVAL_BILLS: generatePermission("PT07"),
      APPROVAL_PAYMENT_BILL: generatePermission("PT08"),
      APPROVAL_PAYMENT_BILL_SERVICE: generatePermission("PT09"),
      APPROVAL_REJECT: generatePermission("PT10"),
      APPROVAL_DEPOSIT: generatePermission("PT11"),
      APPROVAL_REPLACEMENT_RECEIPT: generatePermission("PT12"),
      EDIT_BILL: generatePermission("PT13"),
      CREATE_DIRECT_BILL: generatePermission("PT14"),
    }),
    REPORT: generatePermissionGroup({
      /**
       * NOTE:
       * 1. Hak akses yang baru di setup baru hanya DASHBOARD ( PP15 ) saja dikarenakan menu yang lain belum di develope
      */
      AGING_SUMMARY: generatePermission("PP15"),
      AGING_DETAIL: generatePermission("PP15"),
      PURCHASE_SUMMARY: generatePermission("PP15"),
      PURCHASE_DETAIL: generatePermission("PP15"),
      ANALYSE_PURCHASE_PERIODE: generatePermission("PP15"),
      ANALYSE_PURCHASE_COMPARATION: generatePermission("PP15"),
      ANALYSE_PURCHASE_MONTHLY: generatePermission("PP15"),
      VENDOR_PURCHASE_SUMMARY: generatePermission("PP15"),
      VENDOR_PURCHASE_DETAIL: generatePermission("PP15"),
      BILL_TRANSACTION_SUMMARY: generatePermission("PP15"),
      BILL_TRANSACTION_DETAIL: generatePermission("PP15"),
      SUPPLIER_PAYMENT: generatePermission("PP15"),
      SUPPLIER_PAYMENT_HISTORY: generatePermission("PP15"),
      PURCHASE_PAYABLE_JOURNAL: generatePermission("PP15"),
      DASHBOARD: generatePermission("PP15"),
    }),
    JOURNAL: generatePermissionGroup({
      /** 
       * NOTE: 
       * 1. Permission GENERAL belum di setup
       * 2. Permission TRANSFER MONEY belum di setup
       * 3. Permission DISBURSMENT belum di setup
       * 4. Permission RECEIPTS belum di setup
       * 5. Permission SALE belum di setup
       * 6. Yang baru di setup cuman Permission PURCHASES ( PJ06 ) tetapi di bagian tab belum di setup hak aksesnya
       * 7. Permission INVENTORY belum di setup
       * 8. Permission ALL belum di setup
      */
     GENERAL: generatePermission("PJ06")
    }),
    FIND: generatePermissionGroup({
      /** 
       * NOTE:
       * 1. Cuman perlu setup perminssion PURCHASES ( PF04 ) saja dikarenakan default tab CARD
      */
     PURCHASES: generatePermission("PF04")
    })
  },
  INVENTORY: {
    REGISTER: generatePermissionGroup({
      REGISTER_GROUP: generatePermission("IR01"),
      TRANSFER: generatePermission("IR02"),
      RECEIVED: generatePermission("IR07"),
      COUNT: generatePermission("IR04"),
      ADJUSTMENT: generatePermission("IR03"),
      BUILD_ITEM: generatePermission("IR05"),
      REQUIEST_FROM: generatePermission("IR06"),
    }),
    TRANSACTION: generatePermissionGroup({
      CREATE_ITEM: generatePermission("IT01"),
      CREATE_BUILD_ITEM: generatePermission("IT03"),
      CREATE_TRANSFER_ITEM: generatePermission("IT10"),
      CREATE_RECEIVED_ITEM: generatePermission("IT13"),
      CREATE_COUNT_ITEM: generatePermission("IT06"),
      CREATE_ADJUSTMENT_ITEM: generatePermission("IT05"),
      APPROVAL_TRANSFER_ITEM: generatePermission("IT11"),
      APPROVAL_RECEIVED_ITEM: generatePermission("IT12"),
      APPROVAL_ADJUSTMENT_ITEM: generatePermission("IT14"),
      APPROVAL_BUILD: generatePermission("IT17"),
      SET_ITEM_PRICE: generatePermission("IT02"),
      SET_STOCK_BY_LOCATION: generatePermission("IT16"),
      SET_STOCK_GLOBAL: generatePermission("IT18"),
    }),
    REPORT: generatePermissionGroup({
      /**
       * NOTE:
       * 1. Hak akses menu ITEM LIST SUMMARY belum di setup karena menu belum di develope
       * 2. Hak akses menu ITEM LIST DETAIL belum di setup karena menu belum di develope
       * 3. Hak akses menu ANALYSE INVENTORY SUMMARY belum di setup karena menu belum di develope
       * 4. Hak akses menu ANALYSE INVENTORY DETAIL belum di setup karena menu belum di develope
       * 5. Hak akses menu BUILD COMPONENT belum di setup karena menu belum di develope
       * 6. Hak akses menu INVENTORY COUNT SHEET belum di setup karena menu belum di develope
       * 7. Hak akses menu PRICING SUMMARY belum di setup karena menu belum di develope
       * 8. Hak akses menu INVENTORY JOURNAL belum di setup karena menu belum di develope
      */
      ITEM_LIST_SUMMARY: generatePermission("IP01"),
      ITEM_LIST_DETAIL: generatePermission("IP02"),
      ITEM_DETAIL_STOCK_BY_LOCATION: generatePermission("IP03"),
      ITEM_DETAIL_STOCK_GLOBAL: generatePermission("IP13"),
      ANALYSE_INVENTORY_SUMMARY: generatePermission("IP04"),
      ANALYSE_INVENTORY_DETAIL: generatePermission("IP05"),
      BUILD_COMPONENT: generatePermission("IP06"),
      INVENTORY_MOVEMENT: generatePermission("IP14"),
      INVENTORY_COUNT_SHEET: generatePermission("IP07"),
      PRICING_SUMMARY: generatePermission("IP08"),
      PRICING_ANALYSE: generatePermission("IP09"),
      INVENTORY_JOURNAL: generatePermission("IP10"),
      STOCK_ALERT: generatePermission("IP11"),
      DASHBOARD: generatePermission("IP12"),
    }),
    JOURNAL: generatePermissionGroup({
      /** 
       * NOTE: 
       * 1. Yang baru di setup cuman Permission GENERAL ( IJ01 ) tetapi di bagian tab belum di setup hak aksesnya
       * 2. Permission TRANSFER MONEY belum di setup
       * 3. Permission DISBURSMENT belum di setup
       * 4. Permission RECEIPTS belum di setup
       * 5. Permission SALE belum di setup
       * 6. Permission PURCHASES belum di setup
       * 7. Permission INVENTORY belum di setup
       * 8. Permission ALL belum di setup
      */
     GENERAL: generatePermission("IJ01")
    }),
    FIND: generatePermissionGroup({
      /** 
       * NOTE:
       * 1. Cuman perlu setup perminssion INVENTORY ( IF05 ) saja dikarenakan default tab CARD
      */
     INVENTORY: generatePermission("IF05")
    })
  },
  CARDS: {
    REGISTER: generatePermissionGroup({
      EMPLOYEE: generatePermission("CR01"),
      CUSTOMER: generatePermission("CR02"),
      VENDOR: generatePermission("CR03"),
      SCHEDULE: generatePermission("CR04")
    }),
    TRANSACTION: generatePermissionGroup({
      /** NOTE: Permission CT01 tidak ada karena menu sebelumnya yang menggunakan code tersebut (CT01) telah dihapus */
      CREATE_NEW_EMPLOYEE: generatePermission("CT02"),
      CREATE_NEW_CUSTOMER: generatePermission("CT03"),
      CREATE_NEW_VENDOR: generatePermission("CT04"),
      CREATE_NEW_INVESTOR: generatePermission("CT05"),
      CREATE_SHIFT_SCHEDULE: generatePermission("CT06"),
      APPROVAL_SCHEDULE: generatePermission("CT07"),
    }),
    REPORT: generatePermissionGroup({
      /** 
       * NOTE: 
       * 1. Permission CP03 sudah disetup tetapi menu belum di develope ( saat develope menu CARD TRANSACTION tidak perlu lagi setup permission )
       * 2. Permission CP04 sudah disetup tetapi menu belum di develope ( saat develope menu OVERDUE CONTACT tidak perlu lagi setup permission )
       * 3. Permission CP05 sudah disetup tetapi menu belum di develope ( saat develope menu DASHBOARD tidak perlu lagi setup permission )
      */
      CARD_LIST_SUMMARY: generatePermission("CP01"),
      CARD_LIST_DETAIL: generatePermission("CP02"),
      CARD_TRANSACTION: generatePermission("CP03"),
      OVERDUE_CONTACT: generatePermission("CP04"),
      DASHBOARD: generatePermission("CP05")
    }),
    JOURNAL: generatePermissionGroup({
      /** 
       * NOTE: 
       * 1. Yang baru di setup cuman Permission GENERAL ( CJ01 ) tetapi di bagian tab belum di setup hak aksesnya
       * 2. Permission TRANSFER MONEY belum di setup
       * 3. Permission DISBURSMENT belum di setup
       * 4. Permission RECEIPTS belum di setup
       * 5. Permission SALE belum di setup
       * 6. Permission PURCHASES belum di setup
       * 7. Permission INVENTORY belum di setup
       * 8. Permission ALL belum di setup
      */
     GENERAL: generatePermission("CJ01")
    }),
    FIND: generatePermissionGroup({
      /** 
       * NOTE:
       * 1. Cuman perlu setup perminssion CARD ( CF06 ) saja dikarenakan default tab CARD
      */
     CARDS: generatePermission("CF06")
    })
  }
};